import { action, observable, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import TrackingStore from './TrackingStore';
import { CarrierStore } from 'modules/carrier/stores';
import { TrackingForm } from 'modules/order/forms';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';

class TrackingViewStore extends BaseViewStore {
	@observable trackingStatus;
	@observable isSubmitted = false;
	form = new TrackingForm();

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.trackingStore = new TrackingStore(this.rootStore);
		this.initialize();
	}

	@action.bound async initialize() {
		this.suspend();
		this.carrierDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('carrierId'),
			store: new CarrierStore(this.rootStore),
			onChangeCallback: value => {
				if (value) this.isSubmitted = false;
			},
		});
		this.form.$('trackingNumber').onChange = e => {
			this.form.$('trackingNumber').set('value', e.currentTarget.value);
			this.form.$('trackingNumber').validate();
			this.isSubmitted = false;
		};
		this.resume();
	}

	@action.bound
	onKeyPress = e => {
		if (e.key === 'Enter') {
			if (this.form.$('trackingNumber').value.trim() !== '' && this.carrierDropdownStore.value !== null) {
				this.track();
			} else {
				this.form.showErrors(true);
			}
		}
	};

	@action.bound
	track = async () => {
		this.suspend();
		try {
			await this.trackingStore.track({
				carrierId: this.form.$('carrierId').value,
				trackingNumber: this.form.$('trackingNumber').value.trim(),
			});
			if (this.trackingStore.response != null && this.trackingStore.response.length > 0) {
				this.trackingStatus = this.trackingStore.response[0].trackingStatus;
			} else {
				this.trackingStatus = null;
			}
			this.isSubmitted = true;
		} catch (err) {
			this.rootStore.notificationStore.error(err);
		}
		this.resume();
	};
}

export default TrackingViewStore;
